import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {isUhcEnabled} from 'libs/rollout';

/**
 * Modify an error message for analytics based on UHC rollout status.
 *
 * When the UHC (Unified Health Care) feature toggle is enabled,
 * the error string will be prefixed with "(UHC) " to tag UHC‑related errors.
 *
 * @param error - The original error message.
 * @returns The transformed (or original) error message for analytics.
 */
export const getErrorModified = (error: string): string =>
    isUhcEnabled() ? `(UHC) ${error}` : error;

/**
 * Dispatches a desktop analytics event for errors encountered in a Primer flow.
 *
 * This function checks whether an error is present, applies any necessary
 * transformations via getErrorModified, and then calls the analytics library
 * to record a "Checkout payment-step" event.  The event payload will contain
 * a "message" field prefixed with "Error -" and will include a "prevalidate -"
 * tag if the error occurred during the pre-validation phase.
 */
export const sendPrimerErrorEvent = ({error, method}: {error: string; method: string}): void => {
    if (!error) return;

    const errorModified = getErrorModified(error);
    sendDesktopAnalyticsEvent(
        CHECKOUT_PAYMENT_STEP,
        {
            message: `Error - ${errorModified} - Place Order CTA`,
            method,
        },
        false,
    );
};
